import Vue from 'vue';
import {
  ADMIN_ADD_QUESTION_ERROR,
  ADMIN_ADD_QUESTION_REQUEST,
  ADMIN_ADD_QUESTION_SUCCESS,
  ADMIN_ADD_TAG_ERROR,
  ADMIN_ADD_TAG_REQUEST,
  ADMIN_ADD_TAG_SUCCESS,
  ADMIN_DELETE_QUESTION_ERROR,
  ADMIN_DELETE_QUESTION_REQUEST,
  ADMIN_DELETE_QUESTION_SUCCESS,
  ADMIN_DELETE_TAG_ERROR,
  ADMIN_DELETE_TAG_REQUEST,
  ADMIN_DELETE_TAG_SUCCESS,
  ADMIN_GET_QUESTIONS_ERROR,
  ADMIN_GET_QUESTIONS_REQUEST,
  ADMIN_GET_QUESTIONS_SUCCESS,
  ADMIN_GET_TAGS_ERROR,
  ADMIN_GET_TAGS_REQUEST,
  ADMIN_GET_TAGS_SUCCESS,
  ADMIN_UPDATE_QUESTION_ERROR,
  ADMIN_UPDATE_QUESTION_REQUEST,
  ADMIN_UPDATE_QUESTION_SUCCESS,
  ADMIN_UPDATE_TAG_ERROR,
  ADMIN_UPDATE_TAG_REQUEST,
  ADMIN_UPDATE_TAG_SUCCESS,
  ADMIN_GET_TAG_REQUEST,
  ADMIN_GET_TAG_ERROR,
  ADMIN_GET_TAG_SUCCESS,
  ADMIN_GET_QUESTION_REQUEST,
  ADMIN_GET_QUESTION_SUCCESS, ADMIN_GET_QUESTION_ERROR
} from './actiontypes'
import adminApi from '../../../_services/api/administration';
import questionApi from '../../../_services/api/question';

const state = {
  questions: [],
  tags: [],
  tag: {},
  question: {},
  status: '',
  errors: [],
  hasLoadedOnce: false,
};

const getters = {
  getQuestions: state => state.questions,
  getTags: state => state.tags,
};

const actions = {
  [ADMIN_GET_QUESTIONS_REQUEST]: ({ commit, dispatch }, payload={}) => {
    return new Promise((resolve, reject) => {
      commit(ADMIN_GET_QUESTIONS_REQUEST);
      questionApi.getQuestions(payload)
        .then((response) => {
          if (response.success === true) {
            commit(ADMIN_GET_QUESTIONS_SUCCESS, response.data);
            resolve(response);
          }
          else {
            commit(ADMIN_GET_QUESTIONS_ERROR, response);
            reject(response.error);
          }
        })
        .catch((error) => {
          commit(ADMIN_GET_QUESTIONS_ERROR, error);
          reject(error);
        });
    });
  },
  [ADMIN_GET_QUESTION_REQUEST]: ({ commit, dispatch }, question_id) => {
    return new Promise((resolve, reject) => {
      commit(ADMIN_GET_QUESTION_REQUEST);
      questionApi.getQuestion(question_id)
        .then((response) => {
          if (response.success === true) {
            commit(ADMIN_GET_QUESTION_SUCCESS, response.data);
            resolve(response);
          }
          else {
            commit(ADMIN_GET_QUESTION_ERROR, response);
            reject(response.error);
          }
        })
        .catch((error) => {
          commit(ADMIN_GET_QUESTION_ERROR, error);
          reject(error);
        });
    });
  },
  [ADMIN_ADD_QUESTION_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(ADMIN_GET_QUESTIONS_REQUEST);
      questionApi.addQuestion(payload)
        .then((response) => {
          if (response.success === true) {
            commit(ADMIN_GET_QUESTIONS_SUCCESS, response.data);
            resolve(response);
          }
          else {
            commit(ADMIN_GET_QUESTIONS_ERROR, response);
            reject(response.error);
          }
        })
        .catch((error) => {
          commit(ADMIN_GET_QUESTIONS_ERROR, error);
          reject(error);
        });
    });
  },
  [ADMIN_UPDATE_QUESTION_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(ADMIN_UPDATE_QUESTION_REQUEST);
      questionApi.updateQuestion(payload)
        .then((response) => {
          if (response.success === true) {
            commit(ADMIN_UPDATE_QUESTION_SUCCESS, response.data);
            resolve(response);
          }
          else {
            commit(ADMIN_UPDATE_QUESTION_ERROR, response);
            reject(response.error);
          }
        })
        .catch((error) => {
          commit(ADMIN_UPDATE_QUESTION_ERROR, error);
          reject(error);
        });
    });
  },
  [ADMIN_DELETE_QUESTION_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(ADMIN_DELETE_QUESTION_REQUEST);
      questionApi.deleteQuestion(payload)
        .then((response) => {
          if (response.success === true) {
            commit(ADMIN_DELETE_QUESTION_SUCCESS, response.data);
            resolve(response);
          }
          else {
            commit(ADMIN_DELETE_QUESTION_ERROR, response);
            reject(response.error);
          }
        })
        .catch((error) => {
          commit(ADMIN_DELETE_QUESTION_ERROR, error);
          reject(error);
        });
    });
  },
  [ADMIN_GET_TAGS_REQUEST]: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      commit(ADMIN_GET_TAGS_REQUEST);
      adminApi.getTags()
        .then((response) => {
          if (response.success === true) {
            commit(ADMIN_GET_TAGS_SUCCESS, response.data);
            resolve(response);
          }
          else {
            commit(ADMIN_GET_TAGS_ERROR, response);
            reject(response.error);
          }
        })
        .catch((error) => {
          commit(ADMIN_GET_TAGS_ERROR, error);
          reject(error);
        });
    });
  },
  [ADMIN_GET_TAG_REQUEST]: ({ commit, dispatch }, tag_id) => {
    return new Promise((resolve, reject) => {
      commit(ADMIN_GET_TAG_REQUEST);
      adminApi.getTag(tag_id)
        .then((response) => {
          if (response.success === true) {
            commit(ADMIN_GET_TAG_SUCCESS, response.data);
            resolve(response);
          }
          else {
            commit(ADMIN_GET_TAG_ERROR, response);
            reject(response.error);
          }
        })
        .catch((error) => {
          commit(ADMIN_GET_TAG_ERROR, error);
          reject(error);
        });
    });
  },
  [ADMIN_ADD_TAG_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(ADMIN_ADD_TAG_REQUEST);
      adminApi.addTag(payload)
        .then((response) => {
          if (response.success === true) {
            commit(ADMIN_ADD_TAG_SUCCESS, response.data);
            dispatch(ADMIN_GET_TAGS_REQUEST);
            resolve(response);
          }
          else {
            commit(ADMIN_ADD_TAG_ERROR, response);
            reject(response.error);
          }
        })
        .catch((error) => {
          commit(ADMIN_ADD_TAG_ERROR, error);
          reject(error);
        });
    });
  },
  [ADMIN_UPDATE_TAG_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(ADMIN_UPDATE_TAG_REQUEST);
      adminApi.updateTag(payload)
        .then((response) => {
          if (response.success === true) {
            commit(ADMIN_UPDATE_TAG_SUCCESS, response.data);
            dispatch(ADMIN_GET_TAGS_REQUEST);
            resolve(response);
          }
          else {
            commit(ADMIN_UPDATE_TAG_ERROR, response);
            reject(response.error);
          }
        })
        .catch((error) => {
          commit(ADMIN_UPDATE_TAG_ERROR, error);
          reject(error);
        });
    });
  },
  [ADMIN_DELETE_TAG_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(ADMIN_DELETE_TAG_REQUEST);
      adminApi.deleteTag(payload)
        .then((response) => {
          if (response.success === true) {
            commit(ADMIN_DELETE_TAG_SUCCESS, response.data);
            dispatch(ADMIN_GET_TAGS_REQUEST);
            resolve(response);
          }
          else {
            commit(ADMIN_DELETE_TAG_ERROR, response);
            reject(response.error);
          }
        })
        .catch((error) => {
          commit(ADMIN_DELETE_TAG_ERROR, error);
          reject(error);
        });
    });
  },
};

const mutations = {
  [ADMIN_GET_QUESTIONS_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [ADMIN_GET_QUESTIONS_SUCCESS]: (state, response) => {
    state.status = 'success';
    Vue.set(state, 'questions', response.questions);
    state.hasLoadedOnce = true;
  },
  [ADMIN_GET_QUESTIONS_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [ADMIN_GET_QUESTION_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [ADMIN_GET_QUESTION_SUCCESS]: (state, response) => {
    state.status = 'success';
    Vue.set(state, 'question', response.question);
    state.hasLoadedOnce = true;
  },
  [ADMIN_GET_TAG_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [ADMIN_ADD_QUESTION_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [ADMIN_ADD_QUESTION_SUCCESS]: (state, response) => {
    state.status = 'success'
    state.hasLoadedOnce = true;
  },
  [ADMIN_ADD_QUESTION_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [ADMIN_UPDATE_QUESTION_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [ADMIN_UPDATE_QUESTION_SUCCESS]: (state, response) => {
    state.status = 'success'
    state.hasLoadedOnce = true;
  },
  [ADMIN_UPDATE_QUESTION_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [ADMIN_DELETE_QUESTION_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [ADMIN_DELETE_QUESTION_SUCCESS]: (state, response) => {
    state.status = 'success'
    state.hasLoadedOnce = true;
  },
  [ADMIN_DELETE_QUESTION_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [ADMIN_GET_TAGS_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [ADMIN_GET_TAGS_SUCCESS]: (state, response) => {
    state.status = 'success';
    Vue.set(state, 'tags', response.tags);
    state.hasLoadedOnce = true;
  },
  [ADMIN_GET_TAGS_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [ADMIN_GET_TAG_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [ADMIN_GET_TAG_SUCCESS]: (state, response) => {
    state.status = 'success';
    Vue.set(state, 'tag', response.tag);
    state.hasLoadedOnce = true;
  },
  [ADMIN_GET_TAG_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [ADMIN_ADD_TAG_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [ADMIN_ADD_TAG_SUCCESS]: (state, response) => {
    state.status = 'success'
    state.hasLoadedOnce = true;
  },
  [ADMIN_ADD_TAG_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [ADMIN_UPDATE_TAG_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [ADMIN_UPDATE_TAG_SUCCESS]: (state, response) => {
    state.status = 'success'
    state.hasLoadedOnce = true;
  },
  [ADMIN_UPDATE_TAG_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [ADMIN_DELETE_TAG_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [ADMIN_DELETE_TAG_SUCCESS]: (state, response) => {
    state.status = 'success'
    state.hasLoadedOnce = true;
  },
  [ADMIN_DELETE_TAG_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
};
